import { v4 as uuid } from "uuid";
import { reactive } from "vue";
import { endOfDay, parseISO, startOfDay } from "date-fns";

import { HttpPayload } from "frontend/interfaces/http";
import { PrimaryKey } from "frontend/interfaces/primary-key";
import { Note, NoteNew, NoteRaw } from "frontend/interfaces/note";
import { DateFormat, formatDate } from "shared/utils/date-utils";

export function parseNote(note: NoteRaw): Note {
  return {
    ...note,
    color: note.color ?? "#3b7d8b",
    from: parseISO(note.from),
    to: parseISO(note.to),
    client_resources: {
      ...note.client_resources,
      persons: [...note.client_resources.persons],
    },
  };
}

export function httpPayloadNote(note: Note): HttpPayload {
  return {
    ...note,
    from: note.from ? formatDate(startOfDay(note.from), DateFormat.ISO) : null,
    to: note.to ? formatDate(endOfDay(note.to), DateFormat.ISO) : null,
    client_resources: {
      ...note.client_resources,
      persons: [...note.client_resources.persons],
    },
  };
}

export function newNote(person_id: PrimaryKey | null, date: Date): NoteNew {
  const from = date ?? new Date();

  const result = reactive({
    id: `MOCK-${uuid()}`,
    name: "",
    from: from,
    to: from,
    color: "#3b7d8b",
    color_id: null,
    client_resources: { persons: person_id ? [person_id] : [] },
    unsaved: true,
  });
  return result;
}
